// extracted by mini-css-extract-plugin
export default {"issueType":"InventoryIssuesTable_issueType__31NLF"};